"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreClientCrudService = void 0;
const lodash_1 = require("lodash");
const assignment_1 = require("../../domain/assignment");
const entries_1 = require("../../domain/entries");
const AppError_1 = require("../../domain/errors/AppError");
const results_1 = require("../../domain/results");
/**
 * normally we only write to firebase from the server
 * but we have a few cases that are an exception, which are all in this class
 */
class FirestoreClientCrudService {
    constructor(database) {
        this.database = database;
    }
    async setRealtimeAssignmentSettings(assignmentId, playerSettings) {
        await this.database.write((updates) => {
            updates.updateAssignmentSettings(assignmentId, { playerSettings });
        });
    }
    async setRealtimeTeacherEntry(assignmentId, pinId, teacherEntryUpdate) {
        await this.database.write((updates) => {
            updates.updateTeacherEntry(assignmentId, pinId, teacherEntryUpdate);
        });
    }
    async updateRealtimeComponentSettings(assignmentId, componentSettings) {
        await this.database.write((updates) => {
            updates.updateAssignmentSettings(assignmentId, { componentSettings });
        });
    }
    async setActivePlayerView(assignmentId, view) {
        await this.database.write((updates) => {
            updates.updateAssignmentSettings(assignmentId, { currentView: view });
        });
    }
    /** checks if the given answers are correct and stores the results in firebase */
    async checkAssignmentAnswers(assignmentData, pinId, entries) {
        const pin = assignment_1.AssignmentUtils.pin(assignmentData.content, pinId);
        if (!pin) {
            throw new AppError_1.AppError('not-found');
        }
        const answerBook = new results_1.AnswerBook(assignment_1.AssignmentComplete.asAssignmentData(assignmentData));
        const checkedAnswers = answerBook.checkPinEntries(pin._id, entries);
        // only update those that are changed
        const changed = checkedAnswers.filter((checked) => results_1.CheckedAnswer.isResultChanged(checked));
        await this.updateAnswerResults(assignmentData._id, pin, changed);
    }
    async setRating(itemType, itemId, rating, userId) {
        // TODO Check Mongo if lesson exists, check for existing ratings?
        await this.database.write((updates) => {
            updates.setRating({
                // _id: randomId(),
                _id: 'test',
                createdAt: Date.now(),
                itemId,
                itemType,
                modifiedAt: Date.now(),
                ownerId: userId,
                value: rating,
            });
        });
    }
    /**
     * Stores results for the given user / pin
     * @param assignmentId
     * @param pin
     * @param resultsByUser
     */
    async updateAnswerResults(assignmentId, pin, checkedAnswers) {
        if ((0, lodash_1.isEmpty)(checkedAnswers)) {
            return;
        }
        await this.database.write((update) => {
            checkedAnswers.forEach((checkedAnswer) => {
                const id = entries_1.AssignmentEntry.createId(assignmentId, checkedAnswer.userId);
                update.updateAssignmentEntry(id, {
                    pinEntries: [{ pinId: pin._id, type: pin.type, result: checkedAnswer.result }],
                });
            });
        });
    }
}
exports.FirestoreClientCrudService = FirestoreClientCrudService;
//# sourceMappingURL=FirestoreClientCrudService.js.map